const imgCoordinates = {
  container: document.getElementById('jsContainer') as HTMLElement | null,
  img: document.getElementById('jsImg') as HTMLImageElement | null,
  rows: 14,
  columns: 32,
  coordinates: [] as HTMLElement[],

  init() {
    if (!this.container || !this.img) {
      return;
    }
    this.cacheElements();
    this.positionCoordinates();
    this.addTooltipListeners();
    this.addEventListeners();
  },

  cacheElements() {
    if (!this.container) {
      this.coordinates = [];
      return;
    }

    this.coordinates = Array.from(
      this.container.querySelectorAll('.coordinate'),
    );
  },

  positionCoordinates() {
    if (!this.coordinates.length || !this.container || !this.img) return;

    const imageWidth = this.img.offsetWidth;
    const imageHeight = this.img.offsetHeight;

    const columnWidth = imageWidth / this.columns;
    const rowHeight = imageHeight / this.rows;

    const imageOffsetX = (this.container.offsetWidth - imageWidth) / 2;
    const imageOffsetY = (this.container.offsetHeight - imageHeight) / 2;

    this.coordinates.forEach((coord) => {
      const coordinate = coord.getAttribute('data-coordinate');
      if (!coordinate) return;

      const rowLetter = coordinate[0];
      const columnNumber = parseInt(coordinate.substring(1));

      const rowIndex = rowLetter.charCodeAt(0) - 'A'.charCodeAt(0);
      const columnIndex = columnNumber - 1;

      const left = imageOffsetX + columnIndex * columnWidth + columnWidth / 2;
      const top = imageOffsetY + rowIndex * rowHeight + rowHeight / 2;

      const elementWidth = coord.offsetWidth;
      const elementHeight = coord.offsetHeight;

      coord.style.position = 'absolute';
      coord.style.left = `${left - elementWidth / 2}px`;
      coord.style.top = `${top - elementHeight / 2}px`;
    });
  },
  coordinatePositions: [] as {
    leftPercentage: number;
    topPercentage: number;
  }[],

  addTooltipListeners() {
    this.coordinates.forEach((coord) => {
      coord.addEventListener('click', () => {
        let tooltip = coord.querySelector('.tooltip') as HTMLElement | null;

        if (!tooltip) {
          tooltip = document.createElement('div');
          tooltip.classList.add('tooltip');
          tooltip.innerText = coord.getAttribute('data-description') || '';
          coord.appendChild(tooltip);
        }
        coord.classList.toggle('activeClass');
        tooltip.classList.toggle('activeClass');
      });
    });
  },

  addEventListeners() {
    if (!this.img) return;
    window.addEventListener('resize', this.positionCoordinates.bind(this));
    this.img.addEventListener('load', this.positionCoordinates.bind(this));
  },
};

export default imgCoordinates;
